import React from 'react';
import CSSModules from 'react-css-modules';
import cn from 'classnames';
import PropTypes from 'prop-types';

import RadioMark from '../RadioMark';
import { isIE } from '../../../../utils/browserChecker';

import styles from '../index.styl';

const IS_IE = isIE();

const Input = ({ size, color, onChange, ...rest }) => (
  <div>
    <input
      type="radio"
      {...rest}
      styleName={cn({ input: !IS_IE })}
      onChange={onChange}
    />
    <If condition={!IS_IE}>
      <div styleName="checker">
        <RadioMark {...{ size, color }} checked />
        <RadioMark {...{ size, color }} />
      </div>
    </If>
  </div>
);

Input.propTypes = {
  onChange: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.number,
};

export default CSSModules(Input, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/RadioInput/Input/index.jsx